module.exports = __webpack_public_path__ + "media/components/country-flag/static/lk-dbcb676a8769481e50da9e0ae4e0b30a.svg";